var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:flex lg:items-center lg:w-auto p-3"},[_c('div',{staticClass:"text-center flex items-center"},[_c('ProfileDropDown',{attrs:{"user":_vm.user,"isPreview":_vm.isPreview,"baseUrl":_vm.baseUrl,"logout":_vm.logout,"profile":_vm.profile,"backPortalPage":_vm.backPortalPage,"isPortal":_vm.isPortal}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }